<cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showZeilenSelect]="false">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-detail-manual">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th style="width: 20%">{{ "DatumOderBelegOderEntstehung" | translate }}</th>
    <th style="width: 8%">{{ "Pfandstelle" | translate }}</th>
    <th style="width: 47%">{{ "Bezeichnung" | translate }}</th>
    <th style="width: 25%">{{ "ID-DatumOderBelegOderRechtsgrund" | translate }}</th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (rootBelastungVm of listLoader?.items | orderByPfandrechtBelastung; let i = $index; track i) {
    <ng-template
      [ngTemplateOutlet]="kopfzeile"
      [ngTemplateOutletContext]="{
        rootBelastungVm: rootBelastungVm,
        odd: i % 2
      }">
    </ng-template>

    <ng-template
      [ngTemplateOutlet]="nachrueckungsrecht"
      [ngTemplateOutletContext]="{
        rootBelastungVm: rootBelastungVm,
        odd: i % 2
      }">
    </ng-template>

    <ng-template
      [ngTemplateOutlet]="teilpfandgruppe"
      [ngTemplateOutletContext]="{
        rootBelastungVm: rootBelastungVm,
        odd: i % 2
      }">
    </ng-template>

    <ng-template
      [ngTemplateOutlet]="bemerkung"
      [ngTemplateOutletContext]="{
        rootBelastungVm: rootBelastungVm,
        odd: i % 2
      }">
    </ng-template>

    <ng-template
      [ngTemplateOutlet]="gesamtpfandrecht"
      [ngTemplateOutletContext]="{
        rootBelastungVm: rootBelastungVm,
        odd: i % 2
      }">
    </ng-template>

    <ng-template
      [ngTemplateOutlet]="glaeubiger"
      [ngTemplateOutletContext]="{
        rootBelastungVm: rootBelastungVm,
        odd: i % 2
      }">
    </ng-template>

    <ng-template
      [ngTemplateOutlet]="schuldner"
      [ngTemplateOutletContext]="{
        rootBelastungVm: rootBelastungVm,
        odd: i % 2
      }">
    </ng-template>

    <ng-template
      [ngTemplateOutlet]="gehoertZu"
      [ngTemplateOutletContext]="{
        rootBelastungVm: rootBelastungVm,
        odd: i % 2
      }">
    </ng-template>

    <ng-template
      [ngTemplateOutlet]="imNachgangZu"
      [ngTemplateOutletContext]="{
        rootBelastungVm: rootBelastungVm,
        odd: i % 2
      }">
    </ng-template>

    <ng-template
      [ngTemplateOutlet]="capititel"
      [ngTemplateOutletContext]="{
        rootBelastungVm: rootBelastungVm,
        odd: i % 2
      }">
    </ng-template>
  }
</ng-template>

<ng-template #kopfzeile let-odd="odd" let-rootBelastungVm="rootBelastungVm">
  @for (versionVm of rootBelastungVm.pfandrechtMasterVm.versionenVm; let last = $last; track $index) {
    @for (pfandrechtBelastungVersion of versionVm.pfandrechtBelastungVersions; track $index) {
      <tr [ngClass]="{ even: !odd, odd: odd }">
        <td>
          <div>
            <cap-kompakt-beleg
              [enableNavigation]="isGeschaeftsmodulCapWebErweiterung"
              [histInfo]="serialHistInfos([pfandrechtBelastungVersion.histInfo, versionVm.object.histInfo])"
              [item]="pfandrechtBelastungVersion.beleg"
              [referenzObjectId]="pfandrechtBelastungVersion.id.id"
              [referenzObjectType]="'GRUNDPFANDRECHT'"
              format="BELEG_TYP01">
            </cap-kompakt-beleg>
          </div>
          <cap-kompakt-timepoint [item]="pfandrechtBelastungVersion.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
        </td>
        <td>
          <div [capHistinfo]="serialHistInfos([pfandrechtBelastungVersion.histInfo, versionVm.object.histInfo])" class="me-3 text-center">
            {{ pfandrechtBelastungVersion.pfandstelle }}
          </div>
        </td>
        <td>
          <div>
            <cap-kompakt-grundpfandrecht
              [enableNavigation]="true"
              [histInfo]="serialHistInfos([pfandrechtBelastungVersion.histInfo, versionVm.object.histInfo])"
              [masterId]="rootBelastungVm.pfandrechtMasterVm.object.id"
              [rechteId]="rootBelastungVm.pfandrechtMasterVm.object.rechteId"
              [version]="versionVm.object"
              format="GRUNDPFANDRECHT_TYP02">
            </cap-kompakt-grundpfandrecht>
            <cap-kompakt-timepoint [item]="versionVm.object.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
          </div>
        </td>
        <td>
          <div [capHistinfo]="serialHistInfos([pfandrechtBelastungVersion.histInfo, versionVm.object.histInfo])" class="text-nowrap">
            <cap-link
              [enableNavigation]="isGeschaeftsmodulCapWebErweiterung"
              [queryParams]="getQueryParams(rootBelastungVm.pfandrechtMasterVm.object, versionVm.object)"
              [target]="navTargets.NAV_RECHT"
              [tooltipParams]="{ art: rootBelastungVm.pfandrechtMasterVm.object.rechtArt | translate }">
              {{ rootBelastungVm.pfandrechtMasterVm.object.rechteId | formatRechteId }}
            </cap-link>
            @for (rechtsgrund of rootBelastungVm.rechtsgruende; track $index) {
              @if (rechtsgrund && rechtsgrund.histInfo) {
                <p class="mb-0">
                  <cap-rechtsgrund
                    [histInfo]="serialHistInfos([rootBelastungVm.lastVersion.histInfo, rechtsgrund.histInfo])"
                    [rechtsgrund]="rechtsgrund">
                  </cap-rechtsgrund>
                </p>
              }
            }
          </div>
          <cap-kompakt-timepoint [item]="versionVm.object.histInfo" loeschgeschaeft></cap-kompakt-timepoint>
        </td>
      </tr>
    }
  }
</ng-template>

<ng-template #nachrueckungsrecht let-odd="odd" let-rootBelastungVm="rootBelastungVm">
  @for (
    pfandrechtBelastungVersion of rootBelastungVm.pfandrechtMasterVm.lastVersion.pfandrechtBelastungVersions;
    let first = $first;
    track $index
  ) {
    @if (pfandrechtBelastungVersion.nachrueckungsrecht) {
      <tr [ngClass]="{ even: !odd, odd: odd }">
        <td class="table-subelements">
          {{ first ? ("Vormerkung" | translate) : "" }}
        </td>
        <td></td>
        <td>
          <span>
            {{ "Nachrueckungsrecht" | translate }}
          </span>
          @if (pfandrechtBelastungVersion.codeNachrueckungsArt) {
            <span>{{ pfandrechtBelastungVersion.codeNachrueckungsArt.multilanguageText | translateName }}</span>
          }
        </td>
        <td></td>
      </tr>
    }
  }
</ng-template>

<ng-template #teilpfandgruppe let-odd="odd" let-rootBelastungVm="rootBelastungVm">
  @for (teilpfandgruppe of rootBelastungVm.teilpfandgruppen; let first = $first; track $index) {
    <tr [ngClass]="{ even: !odd, odd: odd }">
      <td class="table-subelements">
        {{ first ? ("Teilbetrag" | translate) : "" }}
      </td>
      <td></td>
      <td>
        <span>{{ "Gruppe" | translate }}</span>
        {{ teilpfandgruppe.bezeichnung }}, {{ teilpfandgruppe.teilbetrag | betrag: true }}
      </td>
    </tr>
  }
</ng-template>

<ng-template #bemerkung let-odd="odd" let-rootBelastungVm="rootBelastungVm">
  @if (rootBelastungVm.pfandrechtMasterVm.lastVersion.object.bemerkung) {
    <tr [ngClass]="{ even: !odd, odd: odd }">
      <td class="table-subelements">{{ "Bemerkung" | translate }}</td>
      <td></td>
      <td>
        <cap-read-more
          [histInfo]="
            serialHistInfos([rootBelastungVm.lastVersion.histInfo, rootBelastungVm.pfandrechtMasterVm.lastVersion.object.histInfo])
          "
          [limit]="100"
          [queryParams]="getQueryParams(rootBelastungVm.pfandrechtMasterVm.object, rootBelastungVm.pfandrechtMasterVm.lastVersion.object)"
          [target]="navTargets.NAV_RECHT"
          [text]="rootBelastungVm.pfandrechtMasterVm.lastVersion.object.bemerkung"
          [textIsLink]="true"
          [tooltipDetail]="{ art: rootBelastungVm.pfandrechtMasterVm.object.rechtArt | translate }">
        </cap-read-more>
      </td>
      <td></td>
    </tr>
  }
</ng-template>

<ng-template #gesamtpfandrecht let-odd="odd" let-rootBelastungVm="rootBelastungVm">
  @if (rootBelastungVm.pfandrechtMasterVm.lastVersion.object.pfandrechtform !== "EINZELPFANDRECHT") {
    @for (belastung of rootBelastungVm.otherBelastungen | orderByPfandrechtBelastungMaster; let first = $first; track $index) {
      <tr [ngClass]="{ even: !odd, odd: odd }" class="invisibleRow">
        <td class="table-subelements">
          @if (first) {
            <span>{{ rootBelastungVm.pfandrechtMasterVm.lastVersion.object.pfandrechtform | translate }}</span>
            <span> {{ "Mit" | translate }}</span>
          }
        </td>
        <td></td>
        <td>
          <cap-kompakt-grundstueck
            [capHistinfo]="
              serialHistInfos([
                belastung.histInfo,
                rootBelastungVm.lastVersion.histInfo,
                rootBelastungVm.pfandrechtMasterVm.lastVersion.object.histInfo
              ])
            "
            [item]="belastung.grundstueck"
            [navigateTo]="navTargetGrundstuecke">
          </cap-kompakt-grundstueck>
          <cap-kompakt-timepoint [item]="belastung.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
        </td>
        <td>
          @for (rechtsgrund of belastung.rechtsgruende; track $index) {
            @if (rechtsgrund && rechtsgrund.histInfo) {
              <p class="mb-0">
                <span [capHistinfo]="serialHistInfos([rootBelastungVm.lastVersion.histInfo, rechtsgrund.histInfo])">
                  {{ rechtsgrund.datum | datum }}
                </span>
                <cap-rechtsgrund
                  [histInfo]="serialHistInfos([rootBelastungVm.lastVersion.histInfo, rechtsgrund.histInfo])"
                  [rechtsgrund]="rechtsgrund">
                </cap-rechtsgrund>
              </p>
            }
          }
        </td>
      </tr>
    }
  }
</ng-template>

<ng-template #glaeubiger let-odd="odd" let-rootBelastungVm="rootBelastungVm">
  @if (rootBelastungVm.pfandrechtMasterVm.object.glaeubiger.length != 0) {
    @for (
      glaeubigerMaster of rootBelastungVm.pfandrechtMasterVm.object.glaeubiger | orderByGlaeubigerSchuldnerMaster;
      let first = $first;
      track $index
    ) {
      <!-- prettier-ignore -->
      @for (glaeubigerVersion of glaeubigerMaster.versions; let last = $last; let
        versionFirst = $first; track $index) {
        <tr [ngClass]="{ even: !odd, odd: odd }" class="invisibleRow">
          <td class="table-subelements">
            @if (first && versionFirst) {
              {{ "detailPfandrechtGlaeubiger" | translate }}
            }
          </td>
          <td></td>
          <td>
            <span
              [capHistinfo]="serialHistInfos([rootBelastungVm.lastVersion.histInfo, glaeubigerVersion.personGb.histInfo])">
              {{ glaeubigerVersion | glaeubigerRolleCode }}
              <cap-kompakt-persongb
                [auskunftsperre]="glaeubigerVersion.personGb.auskunftsperre"
                [enableNavigation]="true"
                [item]="glaeubigerVersion.personGb"
                [itemMasterId]="glaeubigerVersion.personGb.id">
              </cap-kompakt-persongb>
            </span>
            <cap-kompakt-timepoint [item]="glaeubigerMaster.histInfo.bisTimePoint"
                                   loeschgeschaeft></cap-kompakt-timepoint>
          </td>
          <td>
            @if (last) {
              @for (rechtsgrund of glaeubigerMaster.rechtsgruende; track $index) {
                @if (rechtsgrund && rechtsgrund.histInfo) {
                  <p class="mb-0">
                    <cap-rechtsgrund
                      [histInfo]="
                        serialHistInfos([rootBelastungVm.lastVersion.histInfo, glaeubigerVersion.personGb.histInfo, rechtsgrund.histInfo])
                      "
                      [rechtsgrund]="rechtsgrund">
                    </cap-rechtsgrund>
                  </p>
                }
              }
            }
          </td>
        </tr>
      }
    }
  }
</ng-template>

<ng-template #schuldner let-odd="odd" let-rootBelastungVm="rootBelastungVm">
  @if (rootBelastungVm.pfandrechtMasterVm.object.schuldner.length != 0) {
    @for (
      schuldnerMaster of rootBelastungVm.pfandrechtMasterVm.object.schuldner | orderByGlaeubigerSchuldnerMaster;
      let firstMaster = $first;
      track $index
    ) {
      <tr [ngClass]="{ even: !odd, odd: odd }" class="invisibleRow">
        <!-- prettier-ignore -->
        @for (schuldnerVersion of schuldnerMaster.versions; let firstVersion = $first; let last = $last; track $index) {
          <td class="table-subelements">
            @if (firstMaster && firstVersion) {
              {{ "detailPfandrechtSchuldner" | translate }}
            }
          </td>
          <td></td>
          <td>
            <cap-kompakt-persongb
              [auskunftsperre]="schuldnerVersion.personGb.auskunftsperre"
              [capHistinfo]="serialHistInfos([rootBelastungVm.lastVersion.histInfo, schuldnerVersion.personGb.histInfo])"
              [enableNavigation]="true"
              [item]="schuldnerVersion.personGb"
              [itemMasterId]="schuldnerVersion.personGb.id">
            </cap-kompakt-persongb>
            <cap-kompakt-timepoint [item]="schuldnerMaster.histInfo.bisTimePoint"
                                   loeschgeschaeft></cap-kompakt-timepoint>
          </td>
          <td>
            @if (last) {
              @for (rechtsgrund of schuldnerMaster.rechtsgruende; track $index) {
                @if (rechtsgrund && rechtsgrund.histInfo) {
                  <p class="mb-0">
                    <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                  </p>
                }
              }
            }
          </td>
        }
      </tr>
    }
  }
</ng-template>

<ng-template #gehoertZu let-odd="odd" let-rootBelastungVm="rootBelastungVm">
  @for (rechteBeziehung of rootBelastungVm.rechteBeziehungen; let first = $first; track $index) {
    @if (rechteBeziehung.recht.id.id != rootBelastungVm.pfandrechtMasterVm.object.id.id) {
      <tr [ngClass]="{ even: !odd, odd: odd }" class="invisibleRow">
        <td class="table-subelements">
          @if (first) {
            <p>{{ "gehoertZu" | translate }}</p>
          }
        </td>
        <td></td>
        <td [capHistinfo]="rootBelastungVm.pfandrechtMasterVm.lastVersion.object.histInfo">
          @if (rechteBeziehung.rechtArt === "PFANDRECHT") {
            <cap-kompakt-grundpfandrecht
              [enableNavigation]="true"
              [masterId]="rechteBeziehung.recht.id"
              [rechteId]="rechteBeziehung.recht.rechteId"
              [version]="rechteBeziehung.recht.version"
              format="GRUNDPFANDRECHT_TYP01"></cap-kompakt-grundpfandrecht>
          } @else {
            <cap-kompakt-standardrecht
              [histInfo]="rechteBeziehung.recht.histInfo"
              [recht]="rechteBeziehung.recht"
              [textLimit]="200"
              format="STANDARDRECHT_TYP01"></cap-kompakt-standardrecht>
          }
          @if (rechteBeziehung.grundstueck.id.id != rootBelastungVm.id?.id) {
            <span>{{ "auf" | translate }} </span>
            <cap-kompakt-grundstueck [item]="rechteBeziehung.grundstueck"></cap-kompakt-grundstueck>
          }
        </td>
        <td></td>
        <td></td>
      </tr>
    }
  }
</ng-template>

<ng-template #imNachgangZu let-odd="odd" let-rootBelastungVm="rootBelastungVm">
    @for (rangregelung of rootBelastungVm.rangregelungen; let first = $first; track $index) {
      <tr [ngClass]="{ even: !odd, odd: odd }" class="invisibleRow">
      @if (rangregelung.geschaeftsnummer) {
        <td class="table-subelements">
          @if (first) {
            {{ "imNachgangZu" | translate }}
          }
        </td>
        <td></td>
        <td
          [capHistinfo]="
            serialHistInfos([rootBelastungVm.lastVersion.histInfo, rootBelastungVm.pfandrechtMasterVm.lastVersion.object.histInfo])
          ">
          @if (rangregelung.vorgaengerMaster?.art === "PFANDRECHT") {
            <cap-kompakt-grundpfandrecht
              [enableNavigation]="true"
              [histInfo]="
                serialHistInfos([rootBelastungVm.lastVersion.histInfo, rootBelastungVm.pfandrechtMasterVm.lastVersion.object.histInfo])
              "
              [masterId]="rangregelung.vorgaengerMaster.id"
              [rechteId]="rangregelung.vorgaengerMaster.rechteId"
              [version]="rangregelung.vorgaengerMaster.version"
              format="GRUNDPFANDRECHT_TYP01"></cap-kompakt-grundpfandrecht>
          } @else {
            <cap-kompakt-standardrecht
              [histInfo]="
                serialHistInfos([rootBelastungVm.lastVersion.histInfo, rootBelastungVm.pfandrechtMasterVm.lastVersion.object.histInfo])
              "
              [recht]="rangregelung.vorgaengerMaster"
              [textLimit]="200"
              format="STANDARDRECHT_TYP01"></cap-kompakt-standardrecht>
          }
          @if (rangregelung.grundstueck && rangregelung.grundstueck.id.id != rootBelastungVm.id?.id) {
            <span> {{ "auf" | translate }} </span>
            <cap-kompakt-grundstueck [item]="rangregelung.grundstueck"></cap-kompakt-grundstueck>
          }
        </td>
        <td class="pt-0">
          <cap-kompakt-beleg
            [histInfo]="rangregelung.histInfo"
            [item]="rangregelung.belegEntry"
            [referenzObjectId]="rangregelung.vorgaengerMaster.id.id"
            [referenzObjectType]="rangregelung.vorgaengerMaster.art"
            format="BELEG_TYP01"></cap-kompakt-beleg>
        </td>
      }
     </tr>
    }
</ng-template>

<ng-template #capititel let-odd="odd" let-rootBelastungVm="rootBelastungVm">
  <tr [ngClass]="{ even: !odd, odd: odd }">
    @for (titel of rootBelastungVm.pfandrechtMasterVm.object.capititel; track $index) {
      @if (!titel.histInfo.bisTimePoint) {
        @let titeleingang = getTiteleingang(titel);
        <td class="table-subelements">{{ "TiteleingangGrundbuch" | translate }}</td>
        <td></td>
        <td>{{ titeleingang }}</td>
        <td></td>
      }
    }
  </tr>
</ng-template>
